import { useState } from "#imports";

export const useHeader = () => {
  const pageName = useState<string>("header_name", () => "");

  return { pageName };
};
